import { render, staticRenderFns } from "./SettingsCreateRegion.vue?vue&type=template&id=a66e21be&scoped=true"
import script from "./SettingsCreateRegion.vue?vue&type=script&lang=js"
export * from "./SettingsCreateRegion.vue?vue&type=script&lang=js"
import style0 from "./SettingsCreateRegion.vue?vue&type=style&index=0&id=a66e21be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66e21be",
  null
  
)

export default component.exports